<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.threshold details") }} 
      </h4>
    </template>
    <template #body>
         <div class="table-responsive custom-dark-table-wrapper">
        <table class="table table-striped dark-table-head mb-0">
            <thead>
                <tr>
                <th> {{ $t("navigations.eCRF form") }} </th>
                <th> {{ $t("navigations.data points") }} </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in criticalInfo.criticalData" :key="item.id">
                    <td> {{  item.templateName }}</td>
                    <td v-if="this.formPage == 'ThresholdPopup'"> 
                        <span v-for="fieldName in item.fieldnames" :key="fieldName"> 
                            {{ fieldName+", "}}
                        </span>
                    </td>
                    <td v-if="this.formPage == 'Critical data inventory'"> 
                        <span v-for="fieldName in item.fieldNames" :key="fieldName"> 
                            {{ fieldName+", "}}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </template>
  </customModal>
</template>

<script src="./ThresholdInfoPopup.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
